export default __webpack_public_path__ + "2542eafc9f318c51291362af70d96095.png";